import * as actionTypes from '../actionTypes';
import * as hierarchyActionTypes from 'features/asset/hierarchy/actionTypes';
import initialState from 'reducers/initialState';
import { assetHierarchiesReducer, assetHierarchyPropertiesReducer } from 'features/asset/hierarchy/reducers';
import { assetImagesReducer } from 'features/asset/image/reducer';
import { CACHE_RESET } from 'actions/eventTypes';
import { LOAD_PROPERTY_DETAILS_STARTED, LOAD_PROPERTY_DETAILS_SUCCESS } from  'features/offer/edit/assets/asset/actionTypes';

function assetDataReducerInternal(state = initialState.assetData, action) {
  switch (action.type) {
    case hierarchyActionTypes.LOAD_ASSET_TYPES_SUCCEEDED:
      return {
        ...state,
        assetTypes: Object.assign([], action.payload.assetTypes, { isLoaded: true })
      };

    case hierarchyActionTypes.LOAD_ASSET_DEFAULTS_SUCCEEDED:
      return {
        ...state,
        defaultAsset: { ...action.payload.defaultAsset, km: 0, workingHours: 0, isLoaded: true }
      };

    case LOAD_PROPERTY_DETAILS_STARTED: {
      return {
        ...state,
        propertyDetails: {
          ...state.propertyDetails,
          [action.id]: {
            loaded: false
          }
        }
      };
    }

    case CACHE_RESET:{
      return {
        ...state,
        propertyDetails: {
        ...initialState.assetData.propertyDetails
        }
       
      };
    }

    case LOAD_PROPERTY_DETAILS_SUCCESS: {
      return {
        ...state,
        propertyDetails: {
          ...state.propertyDetails,
          [action.id]: {
            loaded: true
          }
        }
      };
    }

    case actionTypes.LOAD_ASSET_PROPERTIES_STARTED: {
      const { assetTypeId } = action.payload;
      return {
        ...state,
        properties: {
          byTypeId: {
            ...state.properties.byTypeId,
            [assetTypeId]: {
              loading: true,
              loaded: false
            }
          }
        }
      };
    }

    case actionTypes.LOAD_ASSET_PROPERTIES_SUCCEEDED: {
      const { properties, assetTypeId } = action.payload;
      return {
        ...state,
        properties: {
          byTypeId: {
            ...state.properties.byTypeId,
            [assetTypeId]: {
              ...properties,
              loading: false,
              loaded: true
            }
          }
        }
      };
    }

    case actionTypes.LOAD_MANDATORY_PROPERTIES_CONFIGURED_STARTED: {
      const { key } = action.payload;
      return {
        ...state,
        mandatoryPropertiesConfigured: {
          ...state.mandatoryPropertiesConfigured,
          [key]: {
            loading: true,
            loaded: false
          }
        }
      };
    }

    case actionTypes.LOAD_MANDATORY_PROPERTIES_CONFIGURED_SUCCEEDED: {
      const { key, properties } = action.payload;
      return {
        ...state,
        mandatoryPropertiesConfigured: {
          ...state.mandatoryPropertiesConfigured,
          [key]: {
            properties,
            loading: false,
            loaded: true
          }
        }
      };
    }

    default:
      return state;
  }
}

export default function assetDataReducer(state = initialState.assetData, action) {
  const assetDataReducerState = assetDataReducerInternal(state, action);
  const assetHierarchiesState = assetHierarchiesReducer(assetDataReducerState.hierarchies, action);
  const assetImagesState = assetImagesReducer(assetDataReducerState.images, action);
  const assetHierarchyPropertiesState = assetHierarchyPropertiesReducer(assetDataReducerState.assetHierarchyProperties, action);
  return {
    ...assetDataReducerState,
    hierarchies: {
      ...assetHierarchiesState
    },
    images: {
      ...assetImagesState
    },
    assetHierarchyProperties: {
      ...assetHierarchyPropertiesState
    }
  };
}
